(function(config) {
    'use strict';

    angular.module('news.services', [
            'ngResource'
        ])
        .factory('newsDataSrvc', newsDataSrvc)
        .factory('newsSrvc', newsSrvc);

    newsDataSrvc.$inject = ['$resource', 'transformRequestSrvc'];

    function newsDataSrvc($resource, transformRequestSrvc) {
        return $resource(config.api + '/api/v1/news/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET',
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            update: {
                method: 'PATCH',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    newsSrvc.$inject = ['newsDataSrvc', 'modalSrvc'];

    function newsSrvc(newsDataSrvc, modalSrvc) {

        return {
            remove: remove,
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    newsDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }

})(window.config);
